import axios from 'axios';
import { present } from '@/shared/utils/typescript';
import { formatVehicleData } from '@/vehicle/converters/vehicleConverters';
import VehicleData from '@/vehicle/models/VehicleData';
import { parseDossierVehicle } from '../converters/dossierVehicleConverters';
import { DossierId } from '../models/AbstractDossier';
import Dossier from '../models/Dossier';
import DossierVehicle from '../models/DossierVehicle';

class DossierVehicleClient {
  async loadByDossier(dossier: Dossier): Promise<DossierVehicle> {
    const response = await axios.get(`/api/mobopro/v1/dossiers/${dossier.id}/object`);
    const dv = present(parseDossierVehicle(response.data));
    dv.dossier = dossier;
    return dv;
  }

  async update(dossierId: DossierId, data: VehicleData): Promise<void> {
    await axios.patch(`/api/mobopro/v1/dossiers/${dossierId}/object`, formatVehicleData(data));
  }
}

export default new DossierVehicleClient();
